import { ExpandedRowWrapper } from '../expanded-row/ExpandedRowWrapper';
import { Item } from '../../types/item.types';
import React from 'react';
import { TableBody as SkapaTableBody } from '@ingka/table';
import { Table } from '@tanstack/react-table';
import { TableRow } from './TableRow';
import styled from '@emotion/styled';
import { theme } from '../../../../shared/styles/core/theme';
import { useTableDataState } from '../../state/table-data.state';

type TableBodyProps = {
   instance: Table<Item>;
   onItemsUpdate: (items: Item[]) => void
};

export const TableBody = ({ instance, onItemsUpdate }: TableBodyProps) => {
   const isLoading = useTableDataState((state) => state.isLoading);

   const rows = instance.getRowModel().rows;
   const columns = instance.getVisibleFlatColumns();

   return (
      <SkapaTableBody>
         {(rows.length > 0 &&
            rows.map((row, index) => {
               return (
                  <React.Fragment key={row.id}>
                     <TableRow row={row} index={index} instance={instance} onItemsUpdate={onItemsUpdate} />
                     <ExpandedRowWrapper
                        columnSpan={columns.length}
                        subItems={row.original?.subItems}
                        parentIndex={row.index}
                        parentItem={row.original}
                     />
                  </React.Fragment>
               );
            })) || (
               <tr>
                  <StyledEmptyTableData colSpan={columns.length}>{isLoading ? 'Loading data...' : 'No results'}</StyledEmptyTableData>
               </tr>
            )}
      </SkapaTableBody>
   );
};

const StyledEmptyTableData = styled.td`
   text-align: center !important;
   color: ${theme.colors.text.tertiary};
`;
